module.exports = __webpack_public_path__ + "static/parade-2019-house02-2dede56a491effab1ff7073cee11e880.jpg";